import { gql } from "@apollo/client"

export const CHECKOUT_DELIVERY_METHOD_UPDATE = gql`
  mutation checkoutDeliveryMethodUpdate($checkoutId: ID!, $deliveryMethodId: ID!) {
    checkoutDeliveryMethodUpdate(id: $checkoutId, deliveryMethodId: $deliveryMethodId) {
      checkout {
        token
        deliveryMethod {
          __typename
          ... on Warehouse {
            name
          }
          ... on ShippingMethod {
            name
          }
        }
        totalPrice {
          gross {
            amount
            currency
          }
        }
      }
      errors {
        field
        message
      }
    }
  }
`
